module.exports = __webpack_public_path__ + "tinymce.f8d2925604a55d7b8604.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/assets/tinymce/skins/lightgray/fonts/tinymce.ttf
// module id = ../../../../../src/assets/tinymce/skins/lightgray/fonts/tinymce.ttf
// module chunks = styles